import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import Login from 'main/components/dialog/Login';
import Message from 'main/components/dialog/Message';
import RecoverPassword from 'main/components/dialog/RecoverPassword';
import SignUp from 'main/components/dialog/SignUp';
import Header from 'pages/layout/components/Header';
import MenuList from 'pages/layout/components/MenuList';

// import Header from './Header';

const useStyles = makeStyles()({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFF'
    },
    main: {
        display: 'flex',
        overflow: 'hidden',
        flex: 1
    },
    menu: {
        minWidth: 260,
        borderRight: '1px solid #E0E0E0',
        '@media (max-width: 1024px)': {
            minWidth: 0
        },
        '@media (max-width: 480px)': {
            display: 'none'
        }
    },
    content: {
        flex: 1,
        maxHeight: '100%',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    }
});

const BaseLayout = ({ children }) => {
    const { classes } = useStyles();

    return (
        <>
            <div className={classes.container}>
                <Header />
                <div className={classes.main}>
                    <MenuList className={classes.menu} />
                    <div className={classes.content}>{children}</div>
                </div>
            </div>
            <Login />
            <SignUp />
            <RecoverPassword />
            <Message />
        </>
    );
};

BaseLayout.propTypes = {
    children: PropTypes.node
};

export default BaseLayout;
